import { render, staticRenderFns } from "./FormulaAdministration.vue?vue&type=template&id=0c3c4d42&scoped=true"
import script from "./FormulaAdministration.vue?vue&type=script&lang=js"
export * from "./FormulaAdministration.vue?vue&type=script&lang=js"
import style0 from "./FormulaAdministration.vue?vue&type=style&index=0&id=0c3c4d42&prod&lang=scss"
import style1 from "./FormulaAdministration.vue?vue&type=style&index=1&id=0c3c4d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c4d42",
  null
  
)

export default component.exports